import { useCallback } from 'react';
import { TaskPreciseDTO } from '../../api/task';
import { useApplicationContext } from '../application/ApplicationContextProvider';

export const useTaskCanBeCompleted = () => {
    const { currentUser } = useApplicationContext();
    return useCallback(
        (task: TaskPreciseDTO) =>
            task.taskActive && task.assignees.flat(2).some((assignee) => assignee.person.id === currentUser.id),
        [currentUser]
    );
};
